import * as React from "react";

const Users: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 81 70"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                fillRule="evenodd"
                d="M80.68 53.19v16.1h-27.3V49.71c0-3.64-1.1-7.03-2.99-9.85h16.96c7.36 0 13.33 5.97 13.33 13.33m-7.752-31.768c0 7.794-6.318 14.112-14.112 14.112-7.793 0-14.11-6.318-14.11-14.112 0-7.794 6.317-14.112 14.11-14.112 7.794 0 14.112 6.318 14.112 14.112M48.88 49.71v19.58H0V49.71c0-7.36 5.97-13.32 13.33-13.32h22.22c3.92 0 7.44 1.69 9.89 4.38 2.14 2.36 3.44 5.5 3.44 8.94m-8.66-33.93c0 8.71-7.07 15.77-15.78 15.77-8.71 0-15.78-7.06-15.78-15.77C8.66 7.06 15.73 0 24.44 0c8.71 0 15.78 7.06 15.78 15.78"
            />
        </svg>
    );
};

export default React.memo(Users);
